import { useTranslation } from "react-i18next";
import localStorageUtils from "./localStorageUtils";
import { LS_KEY_LANG } from "../consts";

/**
 * Custom hook to manage language changes in the application.
 * Provides the current language and a method to change the language.
 *
 * @returns {Object} An object containing:
 * - `currLang` {string}: The current language code.
 * - `changeLanguage` {Function}: A function to change the language.
 */
export const useLangChanger = () => {
    const { i18n } = useTranslation();
    const currLang = i18n.language;

    /**
     * Changes the application's language and updates the direction attribute.
     *
     * @param {Object} lang - The language object.
     * @param {string} lang.code - The language code (e.g., 'en', 'ar').
     * @param {boolean} lang.isRtl - Whether the language is right-to-left.
     */
    const changeLanguage = (lang) => {
        document.body.setAttribute('dir', lang.isRtl ? 'rtl' : 'ltr');
        document.body.dir = lang.isRtl ? 'rtl' : 'ltr';
        i18n.changeLanguage(lang.code);
        localStorageUtils.setItem(LS_KEY_LANG, lang);
    };

    return { currLang, changeLanguage };
}

export default useLangChanger;